module.exports = __webpack_public_path__ + "Server-Disabled.AzureWebApp.ecac5ad1b123721e8de4c819cfa6f87c.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Disabled.AzureWebApp.png
// module id = 1236
// module chunks = 1